// @ts-nocheck
// Auto-migrated from js/mockData.js
// ---------- 角色（Roles） ----------
const ROLES = {
  sdk_admin: {
    code: "sdk_admin",
    name: "SDK 管理员",
    desc: "管 SDK 版本、用户权限、系统参数",
    avatar: "李",
    user: "李管理",
  },
  operator: {
    code: "operator",
    name: "游戏运营",
    desc: "配置分享、看漏斗、做 A/B、导报表",
    avatar: "张",
    user: "张三",
  },
  developer: {
    code: "developer",
    name: "游戏研发",
    desc: "集成 SDK、调用接口、上报事件",
    avatar: "王",
    user: "王工",
  },
};

// ---------- 权限矩阵（按 4 板块粒度） ----------
//   dashboard：所有人可见（综合一览）
//   dev_tools：研发工具（游戏研发 + SDK 管理员）
//   ops：     运营管理（游戏运营 + SDK 管理员）
//   admin：   管理员功能（仅 SDK 管理员）
const PERMISSIONS = {
  sdk_admin: {
    dashboard: true,
    dev_tools: true,
    ops: true,
    admin: true,
  },
  operator: {
    dashboard: true,
    dev_tools: false,
    ops: true,
    admin: false,
  },
  developer: {
    dashboard: true,
    dev_tools: true,
    ops: false,
    admin: false,
  },
};

// ---------- 当前会话状态（可被 UI 修改） ----------
const SESSION = {
  currentRole: "sdk_admin", // 默认 SDK 管理员（拥有全部权限）
};

export { ROLES, PERMISSIONS, SESSION };
